import classNames from 'classnames';
import React from 'react';

export interface PageLoaderProps {
  label: string;
  id?: string;
  noOverlay?: boolean;
  sectionOverlay?: boolean;
  ariaLive?: React.AriaAttributes['aria-live'];
}

const PageLoader = ({
  label,
  id = 'page-loader',
  noOverlay = false,
  sectionOverlay = false,
  ariaLive = 'assertive',
}: PageLoaderProps): JSX.Element => {
  return (
    <div
      className={classNames({
        'text-center': noOverlay && !sectionOverlay,
        'ver-page-loader-overlay': !noOverlay && !sectionOverlay,
        'ver-page-loader-section-overlay': sectionOverlay,
      })}
    >
      <div className="ver-page-loader" aria-atomic="true" aria-live={ariaLive} aria-labelledby={id}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label id={id} className="usa-sr-only">
          {label}
        </label>
        {/* These divs intentional and are a part of the animation */}
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

PageLoader.sectionParentClassname = 'ver-page-loader-section-overlay-parent';

export default PageLoader;
